/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import React from "react";
import LoginController from "./components/auth/login/loginController";
import {Navigation} from "./util/interfaces";
import {HeaderItem, navigate} from '@dvrd/dvr-controls';
import YtDownloaderController from "./components/dl/ytDownloaderController";
import {Navigate, Route} from "react-router-dom";
import AppRoute from "./components/misc/appRoute";
import App from "./app";

const onNavigate = (route: string, id?: string) => () => {
    navigate(route, false, id);
};

const createHeaderItem = (item: Navigation): HeaderItem => ({
    onClick: onNavigate(item.route, item.scrollId),
    label: item.label,
    children: item.subNavigation?.map(createHeaderItem),
});

export const RouteElements = [
    <Route path='*' element={<App/>}>
        <Route path='downloader' element={
            <AppRoute authenticated>
                <YtDownloaderController/>
            </AppRoute>
        }/>
        <Route path='inloggen' element={
            <AppRoute>
                <LoginController/>
            </AppRoute>
        }/>
        <Route path='*' element={<Navigate to='inloggen'/>}/>
    </Route>
]